import Header from '../../components/Header'
import Footer from '../../components/Footer'
import DeleteModal from '../../components/DeleteModal'
import AddressCard from '../../components/MyAddress/AddressCard'
import EditAddressForm from '../../components/MyAddress/EditAddressForm'
import NewAddressForm from '../../components/MyAddress/NewAddressForm'
import { useState, useEffect } from 'react'
import { Breadcrumb, BreadcrumbItem } from '../../styles/breadcrumb'
import ProfileSideMenu from '../../components/MenuProfile'

import * as S from '../../styles/page-profile'

import { getFaturamentoUF, isInscricaoEstadualIsento } from './validatePJ'

import { useLocation } from 'react-router-dom'
import { getLocalStorageLog } from '../../utils/traceLogAcessos'

import Loader from '../../components/Loader'

import { useAddresses } from '../../hooks/address/useAddresses'

function MeusEnderecos() {
  const { data: userAddress, isFetching } = useAddresses()

  const [current, setCurrent] = useState<any>(1)
  const [showModal, setShowModal] = useState<boolean>(false)
  const [cardId, setCardId] = useState<any>('')

  const openModal = (id: string) => {
    setShowModal((prev) => !prev)
    setCardId(id)
  }

  const inscricaoEstadualIsento = isInscricaoEstadualIsento()
  const faturamentoUf = getFaturamentoUF(userAddress)

  const location = useLocation()

  useEffect(() => {
    getLocalStorageLog(location.pathname)
  }, [])

  return (
    <S.Main>
      <DeleteModal
        showModal={showModal}
        setShowModal={setShowModal}
        setCurrent={setCurrent}
        cardId={cardId}
      />

      <Header />

      {isFetching && <Loader />}

      <S.Profile className="perfil">
        <S.PageContent className="page-content">
          <S.Wrapper className="wrapper">
            <S.ColGroup className="col-group">
              <ProfileSideMenu />
              <S.ProfileContent className="col-9">
                <Breadcrumb>
                  <BreadcrumbItem>Inicio</BreadcrumbItem>
                  <BreadcrumbItem>Meus Endereços</BreadcrumbItem>
                </Breadcrumb>

                {current === 1 || current === 3 ? (
                  <AddressCard
                    address={userAddress}
                    setCurrent={setCurrent}
                    deleteModal={(id) => openModal(id)}
                    setCardId={setCardId}
                  />
                ) : null}

                {current === 0 && (
                  <NewAddressForm
                    setCurrent={setCurrent}
                    inscEstadualIsento={inscricaoEstadualIsento}
                    faturamentoUF={faturamentoUf}
                  />
                )}

                {current === 2 && (
                  <EditAddressForm
                    setCurrent={setCurrent}
                    cardId={cardId}
                    address={userAddress}
                  />
                )}
              </S.ProfileContent>
            </S.ColGroup>
          </S.Wrapper>
        </S.PageContent>
      </S.Profile>

      <Footer />
    </S.Main>
  )
}

export default MeusEnderecos
